@file:OptIn(ExperimentalSerializationApi::class)
package com.gsb.vyapar.bhagya.domain

import com.gsb.vyapar.bhagya.datasource.network.Dto
import com.gsb.vyapar.bhagya.util.getAlphanumeric
import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class User(
    val v: Int = 0,
    val d: D = D()
) {
    @Serializable
    data class D(
        val user: Map<String, String> = mapOf()
    )
}

fun Dto.toUser(): User {
    return User(v = v, d = ProtoBuf.decodeFromByteArray<User.D>(d.decodeBase64Bytes().uncompress(GZIP)))
}

fun User.toDto(): Dto {
    return Dto(v = v, d = ProtoBuf.encodeToByteArray(d).compress(GZIP).encodeBase64())
}

fun String.decodeUserString(): User {
    if ("H4sIAAAAAAAAAAAAAAAAAAAA" == this) {
        return User()
    }
    return try {
        ProtoBuf.decodeFromByteArray<User>(this.decodeBase64Bytes().uncompress(GZIP))
    } catch (e: Exception) {
        User()
    }
}

fun User.encodeUserString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}

fun User.getId(): String {
    return this.d.user[ID].orEmpty()
}

fun User.getMobile(): String {
    return this.d.user[MOBILE].orEmpty()
}

fun User.getEmail(): String {
    return this.d.user[EMAIL].orEmpty()
}

fun User.getImage(): String {
    return this.d.user[IMAGE].orEmpty()
}

fun User.getFirstName(): String {
    return this.d.user[FIRST_NAME].orEmpty()
}

fun User.getLastName(): String {
    return this.d.user[LAST_NAME].orEmpty()
}

fun User.getGotra(): String {
    return this.d.user[GOTRA].orEmpty()
}

fun User.getKuldev(): String {
    return this.d.user[KULDEV].orEmpty()
}

fun User.getCreated(): String {
    return this.d.user[CREATED].orEmpty()
}

fun User.getUpdated(): String {
    return this.d.user[UPDATED].orEmpty()
}

fun User.getPassword(): String {
    return this.d.user[PASSWORD] ?: getId().getAlphanumeric()
}
